try {
    window.$ = window.jQuery = require('jquery');

    window.axios = require('axios');
    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    window.toastr = require('toastr');
    toastr.options = {
        "closeButton": true,
        "progressBar": true,
        "showDuration": "500",
        "hideDuration": "1000",
        "timeOut": "5000"
    };

    toastr.danger = function (options) {
        return toastr.error(options);
    }
} catch (e) {}

require("slick-carousel");


// passive
!function (e) {
    "function" == typeof define && define.amd ? define(e) : e()
}(function () {
    var e,
        t = ["wheel", "mouseout", "mouseleave", "mouseup", "mousedown", "mousemove", "mouseenter", "mousewheel", "mouseover"];
    if (function () {
        var e = !1;
        try {
            var t = Object.defineProperty({}, "passive", {
                get: function () {
                    e = !0
                }
            });
            window.addEventListener("test", null, t), window.removeEventListener("test", null, t)
        } catch (e) {
        }
        return e
    }()) {
        var n = EventTarget.prototype.addEventListener;
        e = n, EventTarget.prototype.addEventListener = function (n, o, r) {
            var i, s = "object" == typeof r && null !== r, u = s ? r.capture : r;
            (r = s ? function (e) {
                var t = Object.getOwnPropertyDescriptor(e, "passive");
                return t && !0 !== t.writable && void 0 === t.set ? Object.assign({}, e) : e
            }(r) : {}).passive = void 0 !== (i = r.passive) ? i : -1 !== t.indexOf(n) && !0, r.capture = void 0 !== u && u, e.call(this, n, o, r)
        }, EventTarget.prototype.addEventListener._original = e
    }
});
// end passive


// dropdown
$(function () {
    $('.u-dropdown-toggle').click(function () {
        if ($(this).hasClass( "dropdown-toggle-open")) {
            $(this).next('.u-dropdown').slideUp();
            $(this).removeClass( "dropdown-toggle-open");
        } else {
            $('.u-dropdown').slideUp();
            $('.u-dropdown-toggle').removeClass( "dropdown-toggle-open");

            $(this).next('.u-dropdown').slideDown();
            $(this).addClass( "dropdown-toggle-open");
        }
    });

    $(document).click(function (e) {
        let target = e.target;
        if (!$(target).is('.u-dropdown-toggle') && !$(target).parents().is('.u-dropdown-toggle')) {
            $('.u-dropdown').slideUp();
            $('.u-dropdown-toggle').removeClass( "dropdown-toggle-open");
        }
    });
});
// end dropdown


// scroll add class body
$(function () {
    setTimeout(() => {
        $(window).scroll(onScroll);
        onScroll();
    }, 100)

    function onScroll() {
        const scroll = $(window).scrollTop();

        if (scroll >= 10) {
            $("body").addClass("nav-scroll");
        } else {
            $("body").removeClass("nav-scroll");
        }
    }
})
// end scroll add class body

// cookie control
window.setCookie = (key, value, time) => {
    const d = new Date();
    d.setTime(d.getTime() + time);
    let expires = "expires=" + d.toUTCString();
    document.cookie = key + "=" + value + ";" + expires + ";path=/";
};

window.getCookie = (key, defaultVal = null) => {
    let name = key + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }

    return defaultVal;
};
// end cookie control

axios.get($('body').data('lang-for-url') + 'api/v1/user-info').then(response => {
    $('.menu-links-right').html(response.data.user_nav_buttons_v2);
    $('meta[name="csrf-token"]').attr('content', response.data.csrf_token);
    $('#header_notification_wrapper').html(response.data.main_header_notification);

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': response.data.csrf_token,
        }
    });

    $('input[type="hidden"][name="_token"]').val(response.data.csrf_token);

    if (response.data.main_header_notification) {
        $('body').addClass('has-header-notification');
    }

    for (const notification of response.data.flash_notifications) {
        let level = notification.level;

        if (level === 'danger') {
            level = 'error';
        }

        toastr[level](notification.message);
    }
});

window.onload = function () {
    $(document).on('click', '.close-custom-notification', function () {
        $(this).closest('.header-notification').hide(500);
        $('body').removeClass('has-header-notification');

        setCookie('hideCustomNotificationMineSite', 1)
    })
}

$('document').ready(function () {
    for (const {method, message} of window.flash_notifications ?? []) {
        toastr[method](message);
    }
});

$('a[data-toggle="simple-modal"]').on('click', function (event) {
    event.preventDefault();
    showSimpleModal(event.currentTarget.dataset.target);
});

let reportIssueFormIsLoaded = false;
function showSimpleModal(selector) {
    const modal = $(selector);
    modal.addClass('show');

    if (modal.prop('id') === 'report_issue_modal') {
        if (!reportIssueFormIsLoaded) {
            reportIssueFormIsLoaded = true;
            const reportWrapper = document.getElementById('report_issue_wrapper');

            let scriptElement = document.createElement('script');
            scriptElement.setAttribute('type', 'text/javascript');
            scriptElement.setAttribute('charset', 'utf-8');

            reportWrapper.appendChild(scriptElement);

            scriptElement.addEventListener('load', function () {
                hbspt.forms.create({
                    region: "na1",
                    portalId: "39659202",
                    formId: "fce58ec8-630e-44f9-98b5-7055367828ab",
                    target: "#report_issue_form_placeholder"
                });
            });

            scriptElement.setAttribute('src', '//js.hsforms.net/forms/embed/v2.js');
        }
    }
}

function closeSimpleModal(selector) {
    $(selector).removeClass('show');
}

window.onclick = function(event) {
    const target = event.target;
    if (target.classList.contains('simple-modal') && target.id) {

        closeSimpleModal(`#${target.id}`);
    }
}
